import { ContactFolder, createSelector } from '../../shared';
import type { AppState } from '..';
import type { RenameContactFolderLoadingState } from '../state/view/contactFoldersLoadingState';

export const getDisplayedContactFolders = createSelector<
    AppState,
    ContactFolder[],
    string[],
    RenameContactFolderLoadingState[],
    ContactFolder[]
>(
    'getDisplayedContactFolders',
    [
        (appState: AppState) => appState.data.contactFoldersState.displayedContactFolders || [],
        (appState: AppState) => appState.view.contactFoldersLoadingState.contactFoldersBeingDeleted,
        (appState: AppState) => appState.view.contactFoldersLoadingState.beingRenamedFolders,
    ],
    (displayedContactFolders, contactFoldersBeingDeleted, beingRenamedFolders) => {
        return displayedContactFolders
            .filter(folder => !contactFoldersBeingDeleted.includes(folder.id))
            .map(folder => updateNameForRenamedFolders(folder, beingRenamedFolders));
    }
);

function updateNameForRenamedFolders(
    folder: ContactFolder,
    beingRenamedFolders: RenameContactFolderLoadingState[]
): ContactFolder {
    const renamedFolder = beingRenamedFolders.find(renamed => renamed.folderId === folder.id);

    if (renamedFolder) {
        return {
            ...folder,
            displayName: renamedFolder.newName,
        };
    } else {
        return folder;
    }
}
